import { useCallback } from 'react';
import { useEditorStore } from '~/shell/Store';

export const usePreview = () => {
  const { apiService, training, sequence } = useEditorStore();

  const replaceDomainIfNeeded = useCallback((url: string): string => {
    const isDevSite = window.location.hostname === 'app.easyllama.dev';

    if (isDevSite) {
      return url.replace(/\.com/g, '.dev');
    }

    return url;
  }, []);

  const openPreview = useCallback(
    async (options?: { queryParams?: Record<string, string> }) => {
      if (apiService && training && sequence) {
        const preview = await apiService.getPreviewUrl(
          training.id,
          sequence.id
        );

        if (preview && preview.previewUrl) {
          const modifiedUrl = replaceDomainIfNeeded(preview.previewUrl);
          const url = new URL(modifiedUrl);

          if (options?.queryParams) {
            Object.entries(options.queryParams).forEach(([key, value]) => {
              url.searchParams.set(key, value);
            });
          }

          const newWindow = window.open(url.toString(), '_blank');

          if (newWindow) {
            setTimeout(() => {
              try {
                newWindow.document.title = 'Course Preview - EasyLlama';
              } catch (error) {
                console.log(
                  'Cannot change window title due to CORS restrictions'
                );
              }
            }, 1000);
          }
        }
      }
    },
    [apiService, training, sequence, replaceDomainIfNeeded]
  );

  return { openPreview };
};
